import axios from 'axios'

/**
 * @desc Fetches all Supplier Users
 * @desc getUserAccess in BFF
 * @param {String} supplierId
 */
export const fetchUsers = (supplierId) =>
  axios
    .get(`/authenticated/user-access?supplierId=${supplierId}`)
    .then((res) => res.data)

/**
 * @desc Update Supplier User Roles
 * @desc updateAccountAccess in BFF
 * @param {String} userEmail
 * @param {Object} payload - contains roles Array
 */
export const updateUserRoles = (userEmail, payload) =>
  axios
    .put('/authenticated/user-access', payload, {
      params: {
        email: userEmail
      }
    })
    .then((res) => res.data)

/**
 * @desc Delete Supplier User
 * @desc removeAccountAccess in BFF
 * @param {String} supplierId
 * @param {String} userEmail
 */
export const deleteUser = (supplierId, userEmail) =>
  axios
    .delete('/authenticated/user-access', {
      params: {
        supplierId,
        email: userEmail
      }
    })
    .then((res) => res.data)

/**
 * @desc Fetches all Supplier Agents
 * @desc getSupplierAgents in BFF
 * @param {String} supplierId
 */
export const fetchAgents = (supplierId) =>
  axios
    .get(`/authenticated/user-access/agents?supplierId=${supplierId}`)
    .then((res) => res.data)

/**
 * @desc Check agent egistration status
 * @param {String} email
 */
export const checkAgentRegistration = (email) =>
  axios
    .get(`/authenticated/user-access/agent/status`, {
      params: {
        email
      }
    })
    .then((res) => res.data)
